import DestructibleType from "../enums/DestructibleType";

interface DestructibleData {
  frameName: string;
  maxHp: number;
  destroyedAmount: number;
  destructibleType: DestructibleType;
}

const DESTRUCTIBLES: { [key in DestructibleType]: DestructibleData } = {
  [DestructibleType.CHEST]: {
    frameName: "chest",
    destroyedAmount: 0,
    maxHp: 0.2,
    destructibleType: DestructibleType.CHEST,
  },
  [DestructibleType.GIFT]: {
    frameName: "gift",
    destroyedAmount: 0,
    maxHp: 0.5,
    destructibleType: DestructibleType.GIFT,
  },
};

export default DESTRUCTIBLES;
